import React from 'react';
import { MessageCircle } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { ChatPhone } from '../ChatPhone';
import { messageCategories } from '../../data/content';
export function WhatsAppSection() {
  return <section className="bg-forest py-16 text-cream md:py-[84px]" data-id="element-272" data-mp="by25ui91lmv1">
      <div className="mx-auto grid max-w-[1120px] items-center gap-12 px-5 md:grid-cols-2" data-id="element-273" data-mp="bwqzcao7q108">
        <div data-id="element-274" data-mp="qleskaal5yn0">
          <SectionHeading align="left" tone="dark" kicker="50 mensajes de WhatsApp" icon={MessageCircle} title={<>
                Nunca más te quedes pensando <em data-id="element-276" data-mp="uojqs0nmve5u">qué responder</em>
              </>} lead="Copias, cambias lo que está entre [corchetes] y envías. Para vender, cobrar, poner límites y fidelizar, con un tono cálido y profesional." data-id="element-275" data-mp="qp2nndvoit3u" />
          <Reveal data-id="element-277" data-mp="2wgzo522knwjx">
            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-278" data-mp="2whhh9ptxtunm">
              {messageCategories.map(c => <li key={c.label} className="flex justify-between gap-2 rounded-[14px] border border-white/15 bg-white/[0.07] px-3.5 py-3 text-[15px] font-semibold" data-id="element-279" data-mp="1xr4wptv4sin5">
                  {c.label}
                  <b className="font-display text-tangerine-light" data-id="element-280" data-mp="2ceq0lpztylw4">{c.count}</b>
                </li>)}
              <li className="flex justify-between gap-2 rounded-[14px] border border-tangerine bg-tangerine px-3.5 py-3 text-[15px] font-semibold text-white" data-id="element-281" data-mp="2gerrd4411uwm">
                Total
                <b className="font-display" data-id="element-282" data-mp="2qdfyh7uh4plj">50</b>
              </li>
            </ul>
          </Reveal>
        </div>
        <Reveal data-id="element-283" data-mp="2vc0xj3xzp38e">
          <ChatPhone data-id="element-284" data-mp="2vck4jpm3q77n" />
        </Reveal>
      </div>
    </section>;
}